/* eslint-disable react/no-unknown-property */
import React, { FunctionComponent } from 'react';
import * as styles from './CardColumnDivider.style';

const CardColumnDivider: FunctionComponent = () => (
  <div css={styles.base} />
);

export default CardColumnDivider;
